import {DataProvider, Identifier} from "react-admin";

// Read every allocation, including those outside the datagrid's current page.
export const getPensionFundAssignment = async (dataProvider: DataProvider, invoiceId: Identifier) => {
  const {data: invoice} = await dataProvider.getOne("invoices", {id: invoiceId});
  const ids: Identifier[] = invoice.invoice_chart_accounts || [];
  const {data: allocations} = ids.length
    ? await dataProvider.getMany("invoicechartaccounts", {ids})
    : {data: []};
  const amount = Number(invoice.pension_fund_amount || 0);
  const allocated = allocations.reduce((total, row) => total + Number(row.amount), 0);
  const remainingCents = Math.round(Number(invoice.amount) * 100) - Math.round(allocated * 100);
  const amountCents = Math.round(amount * 100);

  return {
    amount,
    canAssign: Number.isFinite(amount) && amountCents > 0 && remainingCents > 1
      && amountCents <= remainingCents + 1,
  };
};
